import featureFlagManagerForInitialization from './initializationFeatureFlags';
import Service from './serviceFactory';

const getBaseURL = () => {
  const isKrakendEnabled =
    featureFlagManagerForInitialization.getIsAgencyMarketingKrakendEnable();

  if (isKrakendEnabled) {
    return import.meta.env.VITE_API_KRAKEND_BASEURL ?? 'http://localhost:3000';
  }

  return import.meta.env.VITE_API_BASEURL ?? 'http://localhost:3000';
};

// Pass the function itself, not the result - Service will call it on each request
const KrakendServiceAPI = new Service(getBaseURL);

export { KrakendServiceAPI as default };
